import { useRecordContext } from "react-admin";

import { ENERGY_ARTICLE_CODES } from "../../utils/constants";
import { PriceField } from "./PriceField";

export const EnergyAwarePriceField = ({ currency, ...props }) => {
	const record = useRecordContext();
	if (!record) return null;

	return (
		<PriceField
			{...props}
			source="price"
			record={record}
			mainCurrency={currency}
			asPercent={ENERGY_ARTICLE_CODES.includes(record.article_code)}
		/>
	);
};
